module.exports = __webpack_public_path__ + "static/media/PicturePhone2.6f480e1b.png";